import { axios } from './core';
import { handleResponse, handleError } from './response';

const single = 'user';
const plural = 'users';

// const addCommonHandler = (axiosPromise: Axios) =>
//   axiosPromise.then(handleResponse).catch(handleError);

const getUserById = (id) =>
  axios
    .post(`/${single}/get`, { id })
    .then(handleResponse)
    .then((data) => data ?? {})
    .catch(handleError);

const getFreeSlotCount = (id) =>
  axios
    .post(`/${single}/free_slots/count/get`, id)
    .then(handleResponse)
    .then((data) => data ?? {})
    .catch(handleError);

const getUserByType = (type) =>
  axios
    .post(`/${plural}/get`, { user_type: type })
    .then(handleResponse)
    .catch(handleError);

const updateUser = (newUserData) =>
  axios
    .post(`/${single}/update`, newUserData)
    .then(handleResponse)
    .then((data) => (data ? data.user || data.product : {}))
    .catch(handleError);
    
const updateUserAcceptMarketing = (newUserData) =>
  axios
    .post(`/${single}/upd/accept_marketing`, newUserData)
    .then(handleResponse)
    .then((data) => (data ? data.user || data.product : {}))
    .catch(handleError);

const getUserEarning = (userId = null) =>
  axios
    .post(`/${single}/earnings/get`, { user_id: userId })
    .then(handleResponse)
    .catch(handleError);

const transferFund = (data) =>
  axios
    .post(`/${single}/funds_transfer `, data)
    .then(handleResponse)
    .catch(handleError);

const getReferals = (userId) =>
  axios
    .post(`/${single}/referrals/get`, {
      user_id: userId,
    })
    .then(handleResponse)
    .catch(handleError);

const sendReferral = (data) =>
  axios
    .post(`/${single}/referral/send`, data)
    .then(handleResponse)
    .catch(handleError);

const getUserBraSize = () =>
  axios
    .post(`/${single}/bra_sizes/get`, {})
    .then(handleResponse)
    .catch(handleError);

const getUserHeightList = () =>
  axios
    .post(`/${single}/heights/get`, {})
    .then(handleResponse)
    .catch(handleError);

const getUserBodyType = () =>
  axios
    .post(`/${single}/body_types/get`, {})
    .then(handleResponse)
    .catch(handleError);

const getUserUsuallyWears = () =>
  axios
    .post(`/${single}/usually_wears/get`, {})
    .then(handleResponse)
    .catch(handleError);
const getUserWearFrequencies = () =>
  axios
    .post(`/${single}/wear_frequencies/get`, {})
    .then(handleResponse)
    .catch(handleError);

const getUserWearOccassions = () =>
  axios
    .post(`/${single}/wear_occassions/get`, {})
    .then(handleResponse)
    .catch(handleError);

const userAPI = {
  getUserById,
  getUserByType,
  getUserHeightList,
  updateUser,
  getUserEarning,
  transferFund,
  getReferals,
  getFreeSlotCount,
  getUserBraSize,
  getUserBodyType,
  sendReferral,
  getUserUsuallyWears,
  getUserWearFrequencies,
  getUserWearOccassions,
  updateUserAcceptMarketing,
};

export default userAPI;
